import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import LabelField from '../../components/plain/LabelField';
import FieldDate from '../../components/plain/FieldDate';
import FieldString from '../../components/plain/FieldString';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldInteger from '../../components/plain/FieldInteger';
import FieldReference from '../../components/plain/FieldReference';
import FieldList_Enum from '../../components/plain/FieldList_Enum';
import FieldList_Reference from '../../components/plain/FieldList_Reference';
import FieldList_MultilangString from '../../components/plain/FieldList_MultilangString';
import TabbedPane from '../../components/plain/TabbedPane';
import FieldList_CardsPanel from '../../components/plain/FieldList_CardsPanel';
import FieldList_TableGroup from '../../components/plain/FieldList_TableGroup';
import ButtonSelectInstance from '../../modal/selectinstance/ButtonSelectInstance';

import TabBrDerivatives from './components/TabBrDerivatives';
import TabBrHonors from './components/TabBrHonors';
import TabBrNames from './components/TabBrNames';
import TabBrAuthors from './components/TabBrAuthors';
import TabBrPhysChar from './components/TabBrPhysChar';
import TabBrContent from './components/TabBrContent';
import TabBrIdentification from './components/TabBrIdentification';
import TabBrDocLinks from './components/TabBrDocLinks';
import TabBrTopicLinks from './components/TabBrTopicLinks';
import TabBrFiles from './components/TabBrFiles';
import TabBrImages from './components/TabBrImages';
import TabBrArrange from './components/TabBrArrange';
import DivOfferPanel from './components/DivOfferPanel';
import DivConfirmationList from './components/DivConfirmationList';

import {getLanguage} from '../../util/localStorage';
import {getDefinedValue} from '../../util/tools';
import { PROVIDER_PATH, BOOK_PLAIN_PATH } from '../../util/routes';
import { 
	FORM_PRODUCT_PLAIN, FORM_PROVIDER_TABLE, FORM_AUTHORITY_PUBLISHER_TABLE, FORM_BOOK_TABLE 
} from '../../util/consts/forms';
import { 
	ENUMERATION_CONTRIBUTOR_TYPE, ENUMERATION_LANGUAGE, ENUMERATION_MATERIAL_TYPE, 
	ENUMERATION_SHARE_TYPE, ENUMERATION_TITLE_TYPE, 
	ENUMERATION_DERIVATIVE_TYPE, ENUMERATION_HONOR_TYPE, ENUMERATION_PAGE_TYPE,
	ENUMERATION_PRODUCT_FORM_DETAIL, ENUMERATION_PRICE_QUALIFIER,

} from '../../util/consts/common';
import { AUTHORITY_PUBLISHER_PATH } from '../../util/routes';
import { performApiRequest, ACTION_PRODUCT_BORROW_BOOK_API_URL, MASTER_LOAD_REF_API_URL } from '../../util/restapi';

import insertIcon from '../../assets/icons/png24x24/Search.png';
import linkIcon from '../../assets/icons/png24x24/link.png';
import unlinkIcon from '../../assets/icons/png24x24/link-broken-blue.png';
import clearIcon from '../../assets/icons/png24x24/edit-clear.png';

const refProviderNodes = [
	{
		classId: 'Provider', plainFormPath: PROVIDER_PATH, 
		selectInstanceFormId: FORM_PROVIDER_TABLE,
		selectInstanceFormTitle: 'Постачальники'
	}
];
const refBookNodes = [
	{
		classId: 'Book', plainFormPath: BOOK_PLAIN_PATH, 
		selectInstanceFormId: FORM_BOOK_TABLE,
		selectInstanceFormTitle: 'Books'
	}
];
const refSupplierNodes = [
	{
		classId: 'Provider', plainFormPath: PROVIDER_PATH, 
		selectInstanceFormId: FORM_PROVIDER_TABLE,
		selectInstanceFormTitle: 'Постачальники'
	}
];
const selectBookRvContext = {
	rateView: null,
	form: 'book_table',
	formTitle: 'Книга', 
	data: null
}

class ProductPlainPage extends PlainPage {

	enumContributorType = null;
	enumLanguage = null;
	enumMaterialType = null;
	enumShareType = null;
	enumTitleType = null;
	enumDerivativeType = null;
	enumHonorType = null;
	enumPageType = null;
	enumProductFormDetail = null;
	enumPriceQualifier = null;

	constructor(props) {
		super(props);
		this.formPath = FORM_PRODUCT_PLAIN;
		this.formTitle = 'Продукт';
		this.buildInstanceCard = this.buildProductCard;
	}
	async completeInit() {
		this.enumContributorType = this.realm.getEnumeration( ENUMERATION_CONTRIBUTOR_TYPE );
		this.enumLanguage = this.realm.getEnumeration( ENUMERATION_LANGUAGE );
		this.enumMaterialType = this.realm.getEnumeration( ENUMERATION_MATERIAL_TYPE );
		this.enumShareType = this.realm.getEnumeration( ENUMERATION_SHARE_TYPE );
		this.enumTitleType = this.realm.getEnumeration( ENUMERATION_TITLE_TYPE );
		this.enumDerivativeType = this.realm.getEnumeration( ENUMERATION_DERIVATIVE_TYPE );
		this.enumHonorType = this.realm.getEnumeration( ENUMERATION_HONOR_TYPE );
		this.enumPageType = this.realm.getEnumeration( ENUMERATION_PAGE_TYPE );
		this.enumProductFormDetail = this.realm.getEnumeration( ENUMERATION_PRODUCT_FORM_DETAIL );
		this.enumPriceQualifier = this.realm.getEnumeration( ENUMERATION_PRICE_QUALIFIER );
		
		return true;
	}
	componentDidMount = async () => {
		this.init('Product')
		document.title = 'BOM. ' + this.formTitle;
	}

	onBookSelected = async (ids) => {
		if( ids.length == 0 )
			return;
		let instance = this.state.instance;
		let bean = instance.createBean();
		bean.feVersion = 'plain1';
		let request = {
			master: bean,
			donorId: ids[0],
			mode: '' 
		};
		var response = await performApiRequest( ACTION_PRODUCT_BORROW_BOOK_API_URL, request );
		if( response.success ) {
			bean = response.data;
			this.updateInstance(bean)
			console.log('Borrowed book instance', bean, this.instance);
		} else {
			this.props.app.showResponse( response );
		}
	}
	onLinkBookSelected = async (ids) => {
		if( ids.length == 0 )
			return;
		let response = await performApiRequest( MASTER_LOAD_REF_API_URL, {id: ids[0]} );
		if( response.success ) {
			let instance = this.state.instance;
			let ref = response.data;
			let fieldBookProduct = instance.rootField.value.bookProduct;
			fieldBookProduct.ref = ref;
			instance.setFieldValue(instance.rootField.value.bookRef, ref);
		} else {
			this.props.app.showResponse( response );
		}
	}
	unlinkBookRef = () => {
		let instance = this.state.instance;
		let fieldBookProduct = instance.rootField.value.bookProduct;
		fieldBookProduct.ref = {};
		instance.setFieldValue(instance.rootField.value.bookRef, null);
	}
	clearBookRef = () => {
		let instance = this.state.instance;
		let fieldBookProduct = instance.rootField.value.bookProduct;
		instance.clearField(fieldBookProduct)
		instance.setFieldValue(instance.rootField.value.productForm, '');
		instance.setFieldValue(instance.rootField.value.bookRef, null);
	}

	addContributorName(currentName, contributor, prefix) {
		var currentLanguage = getLanguage();
		var name = null;
		for(let n of contributor.value.names.value) {
			if( n.value.language.value == currentLanguage && n.value.shortName.value ) {
				name = n;
				break;
			}
		}
		if( name == null && contributor.value.names.value.length > 0)
			name = contributor.value.names.value[0];
		if( name != null  && name.value.shortName.value ) {
			var pref = getDefinedValue(prefix, '');
			if( currentName )
				currentName += ', ' + name.value.shortName.value;
			else
				currentName = pref + ' ' + name.value.shortName.value;
		} 
		return currentName;
	}
	buildProductCard = (productInstance) => {
		let currentLanguage = getLanguage();
		let bookProduct = productInstance.rootField.value.bookProduct;
		let card = '';
		
		let titleArea = '';
		let titleAreaCt = ''
		for(let ttl of bookProduct.value.title.value) {
			if(ttl.value.titleType.value == 'Modern') {
				if( ttl.value.language.value == currentLanguage ) {
					titleArea = getDefinedValue(ttl.value.mainName.value, ''); 
					if( ttl.value.subName.value ) 
						titleArea += ": " + ttl.value.subName.value;
					break;
				} else if( ! titleAreaCt ) {
					titleAreaCt = getDefinedValue(ttl.value.mainName.value, '');
				}
			}
		}
		if( titleArea == '' )
			titleArea = titleAreaCt;
		let materialType = bookProduct.value.edition.value.materialType.value;
		if( materialType ) {
			let materialTypeText = this.realm.getEnumerationItemText( this.enumMaterialType, materialType);
			titleArea += ' [' + materialTypeText + ']';
		}

		let author = '', compiler = '', editor = '', translator = '', illustrator = '';
		for(let con of bookProduct.value.contributor.value) {
			let contriburorType = con.value.role.value;
			let contriburorName = this.realm.getEnumerationItemText( this.enumContributorType, contriburorType);
			if( contriburorType == 'A01' ) { // AUTHOR
				author = this.addContributorName(author, con, '');
			} else if( contriburorType == 'C01' ) { // COMPILER
				compiler = this.addContributorName(compiler, con, contriburorName);
			} else if( contriburorType == 'B01' ) { // EDITOR
				editor = this.addContributorName(editor, con, contriburorName);
			} else if( contriburorType == 'B06' ) { // TRANSLATOR
				translator = this.addContributorName(translator, con, contriburorName);
			} else if( contriburorType == 'A12' ) { // ILLUSTRATOR
				illustrator = this.addContributorName(illustrator, con, contriburorName);
			}
		}
		let respArea = author
		if( compiler )
			respArea += (respArea) ? " ; " + compiler : compiler;
		if( editor )
			respArea += (respArea)? " ; " + editor : editor;
		if( translator )
			respArea += (respArea)? " ; " + translator : translator;
		if( illustrator )
			respArea += (respArea)? " ; " + illustrator : illustrator;
		
		card += titleArea;
		if( respArea )
			card += " / " + respArea;
		return card;
	}

	createTab = (tabId) => {
		let instance = this.state.instance;
		let readOnly = this.instanceReadOnly;
		if( tabId == 'provider' )
			return <TabProvider plain={this} instance={instance} readOnly={readOnly} />;
		if( tabId == 'offers' )
			return <TabOffers plain={this} instance={instance} readOnly={readOnly} />;
		if( tabId == 'confirmation' )
			return (
				<div style={{padding: '5px' }}>
					<DivConfirmationList plain={this} instance={instance} path={'confirmations'} 
						readOnly={readOnly} ignoreTitle={true}
					/>
				</div>
			);
		if( tabId == 'derivatives' )
			return <TabBrDerivatives plain={this} instance={instance} readOnly={readOnly} />;
		if( tabId == 'honors' )
			return <TabBrHonors plain={this} instance={instance} readOnly={readOnly} />;

		let fieldBookProduct = instance.rootField.value.bookProduct;
		if( tabId == 'names' )
			return <TabBrNames plain={this} instance={instance} parentField={fieldBookProduct} readOnly={readOnly} />;
		if( tabId == 'authors' )
			return <TabBrAuthors plain={this} instance={instance} parentField={fieldBookProduct} readOnly={readOnly} />;
		if( tabId == 'edition' )
			return <TabEdition plain={this} instance={instance} readOnly={this.instanceReadOnly} />;
		if( tabId == 'physChar' )
			return <TabBrPhysChar plain={this} instance={instance} parentField={fieldBookProduct} readOnly={readOnly} />;
		if( tabId == 'content' )
			return <TabBrContent plain={this} instance={instance} parentField={fieldBookProduct} readOnly={readOnly} />;
		if( tabId == 'identidication' )
			return <TabBrIdentification plain={this} instance={instance} parentField={fieldBookProduct} readOnly={readOnly} />;

		if( tabId == 'docLinks' )
			return <TabBrDocLinks plain={this} instance={instance} parentField={fieldBookProduct} readOnly={readOnly} />;
		if( tabId == 'topicLinks' )
			return <TabBrTopicLinks plain={this} instance={instance} parentField={fieldBookProduct} readOnly={readOnly} />;
		if( tabId == 'files' )
			return <TabBrFiles plain={this} instance={instance} parentField={fieldBookProduct} readOnly={readOnly} />;
		if( tabId == 'images' )
			return <TabBrImages plain={this} instance={instance} parentField={fieldBookProduct} readOnly={readOnly} />;
		if( tabId == 'arrange' )
			return <TabBrArrange plain={this} instance={instance} parentField={fieldBookProduct} readOnly={readOnly} />;
		return null;
	}

	renderBody() {
		let tabs = [
			{
				rowId: 'first',
				tabs: [  
					{ tabId: 'provider', tabTitle: 'Постачальник', },
					{ tabId: 'offers', tabTitle: 'Пропозиції', },
					{ tabId: 'confirmation', tabTitle: 'Супровідні документи', },
					{ tabId: 'derivatives', tabTitle: 'Екранізації', },
					{ tabId: 'honors', tabTitle: 'Відзнаки і нагороди', },
				]
			},
			{
				rowId: 'second',
				tabs: [
					{ tabId: 'names', tabTitle: 'Назви', },
					{ tabId: 'authors', tabTitle: 'Автори', },
					{ tabId: 'content', tabTitle: 'Зміст', },
					{ tabId: 'edition', tabTitle: 'Видання', },
					{ tabId: 'physChar', tabTitle: 'Фізичні характеристики', },
					{ tabId: 'identidication', tabTitle: 'Ідентифікація', },
					{ tabId: 'arrange', tabTitle: 'Упорядкування', },
				]
			},
			{
				rowId: 'third',
				tabs: [
					{ tabId: 'topicLinks', tabTitle: 'Теми класифікатора', },
					{ tabId: 'images', tabTitle: 'Зображення', },
					{ tabId: 'docLinks', tabTitle: 'Зв\'язки з документами', },
					{ tabId: 'files', tabTitle: 'Електронні копії', },
				]
			},

		];
		
		let instance = this.state.instance;
		let readOnly = this.instanceReadOnly;
		
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >

					<div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
						<LabelField instance={instance} path={'/providerRef'}
							styles={{ divMain: {marginRight: '10px'}}} 
						/>
						<FieldEnum instance={instance} path={'/rstype'} plain={this} 
							ignoreTitle={true} styles={{ select: {flexGrow: '0', marginRight: '20px'}}} 
							readOnly={readOnly}
						/>
						<FieldReference instance={instance} path={'/providerRef'} plain={this} 
							refNodes={refProviderNodes} ignoreTitle={true}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', marginRight: '20px'}}} 
						/>
					</div>

					<div style={{display: 'flex', width: '100%', alignItems: 'center', marginBottom: '10px'}}>
						<FieldReference instance={instance} path={'/bookRef'} plain={this} 
							refNodes={refBookNodes} readOnly={true}
							styles={{ divMain: {flexGrow: '1', maxWidth: '1200px'}}} 
						/>

						<div style={{display:'flex', marginLeft: '10px', minWidth: '100px'}}>
							<ButtonSelectInstance
								tooltip={'Пов\'язати з книгою і скопіювати поля'} icon={insertIcon}
								selectInstanceRvContext={selectBookRvContext} 
								onInstanceSelected={this.onBookSelected}
								disabled={readOnly}
								style={{width: '36px', height: '30px', marginLeft: '4px'}}
							/>
							<ButtonSelectInstance
								tooltip={'Пов\'язати з книгою'} icon={linkIcon}
								selectInstanceRvContext={selectBookRvContext} 
								onInstanceSelected={this.onLinkBookSelected}
								disabled={readOnly}
								style={{width: '36px', height: '30px', marginLeft: '4px'}}
							/>
							<button 
								onClick={this.unlinkBookRef} title={'Розірвати посилання'}
								disabled={readOnly}
								style={{width: '36px', height: '30px', marginLeft: '4px'}}
							>
								<img src={unlinkIcon} />
							</button>
							<button 
								onClick={this.clearBookRef} title={'Прибрати посилання і очистити поля документа'}
								disabled={readOnly}
								style={{width: '36px', height: '30px', marginLeft: '4px'}}
							>
								<img src={clearIcon} />
							</button>
						</div>
					</div>

					<div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
						<FieldEnum instance={instance} path={'/pubStatus'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', marginRight: '20px'}}} 
						/>
						<FieldDate instance={instance} path={'/bcudate'} plain={this} 
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', marginRight: '20px'}}} 
						/>
						<FieldEnum instance={instance} path={'/productState'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1'}}} 
						/>
					</div>

					<div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
						<FieldEnum instance={instance} path={'/bookProduct/edition/productForm'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', marginRight: '20px'}}} 
						/>
						<FieldEnum instance={instance} path={'/bookProduct/arrange/litType'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1'}}} 
						/>
					</div>

					<div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
						<FieldString instance={instance} path={'/uri'} plain={this}
							readOnly={readOnly}
							styles={{ divMain: {flexGrow: '1'} }}
						/>
					</div>
					
					<TabbedPane tabs={tabs} createTab={this.createTab} 
						styles={{ divMain: {border: '1px solid gray', marginTop: '10px'} }} 
					/>
				</div>
			</div>
		)
	}
}

class TabProvider extends React.Component {
	
	constructor(props) {
		super(props)
	}
	
	render() {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<div style={{padding: '20px 20px 20px 20px' }}>

				<div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
					<FieldReference instance={instance} path={'/supplierRef'} plain={this} 
						refNodes={refSupplierNodes}
						readOnly={readOnly}
						styles={{ input: {flexGrow: '1'}}} 
					/>
				</div>

				<div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
					<FieldString instance={instance} path={'/number'} plain={plain}
						readOnly={readOnly}
						styles={{ input: {flexGrow: '1', marginRight: '20px'} }}
					/>
					<FieldEnum instance={instance} path={'/supplierRole'} plain={plain} 
						readOnly={readOnly}
						styles={{ select: {flexGrow: '1'}}} 
					/>
				</div>

				<div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
					<FieldEnum instance={instance} path={'/availability'} plain={plain} 
						readOnly={readOnly}
						styles={{ select: {flexGrow: '1', marginRight: '20px'}}} 
					/>
					<FieldInteger instance={instance} path={'/instock'} plain={plain}
						readOnly={readOnly}
						styles={{ input: {flexGrow: '1', maxWidth: '70px', marginRight: '20px'} }}
					/>
					<FieldInteger instance={instance} path={'/packQty'} plain={plain}
						readOnly={readOnly}
						styles={{ input: {flexGrow: '1', maxWidth: '70px', marginRight: '20px'} }}
					/>
					<FieldDate instance={instance} path={'/startDate'} plain={plain} 
						readOnly={readOnly}
						styles={{ input: {flexGrow: '1', marginRight: '20px'}}} 
					/>
					<FieldDate instance={instance} path={'/stopDate'} plain={plain} 
						readOnly={readOnly}
						styles={{ input: {flexGrow: '1'}}} 
					/>
				</div>

			</div>
		)
	}
}
class TabOffers extends React.Component {
	
	constructor(props) {
		super(props)
	}
	
	offerCardHtmlBuilder = (fieldOffer, index) => {
		console.log('fieldOdder', fieldOffer);
		let card = this.offerCardBuilder(fieldOffer, index);
		let state = fieldOffer.value.state.value;
		let cardColor = 'black';
		if( state == 'suspended' )
			cardColor = 'gray';
		else if( state == 'deleted' )
			cardColor = 'green';
		let cardHtml = (
			<div style={{color: cardColor}}>
				{card}
			</div>
		)
		return cardHtml;
	}
	offerCardBuilder = (fieldOffer, index) => {
		let plain = this.props.plain;
		let card = '';

		let priceQualifier = fieldOffer.value.priceQualifier.value;
		let priceQualifierText = null;
		if( priceQualifier ) {
			priceQualifierText = plain.realm.getEnumerationItemText( plain.enumPriceQualifier, priceQualifier);
			card += priceQualifierText;
		}
		
		let price = fieldOffer.value.price.value;
		if( price ) {
			if( card )
				card += ' - ';
			card += price;
		}
		
		return card;
	}
	buildOfferPanel = (fieldGroup, listItemInfo) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (<DivOfferPanel plain={plain} instance={instance} fieldGroup={fieldGroup} isPlain={false} readOnly={readOnly} />);
	}
	
	render() {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<div style={{padding: '20px 20px 20px 20px' }}>
				<FieldList_CardsPanel path={'/offers'} instance={instance} plain={plain} 
					buildItemComponent={this.buildOfferPanel} itemCardHtmlBuilder={this.offerCardHtmlBuilder}
					ignoreTitle={true} labelEmptyToHeader={true} disableMoveItems={true}
					readOnly={readOnly}
					styles={{
						divCardsBlock: {
							marginRight: '10px',
							backgroundColor: 'rgb(240,240,240)',
							minWidth: '200px'
						},
						divCard: {
							marginTop: '3px',
							padding: '7px',
							cursor: 'pointer',
							backgroundColor: 'lightGray',
							minHeight: '18px'
						}
					}}
				/>
			</div>
		)
	}
}
class TabEdition extends React.Component {

	constructor(props) {
		super(props)
	}
	
	render() {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = instance.rootField.value.bookProduct.value.edition;
		let readOnly = this.props.readOnly;
		return (
			<div style={{padding: '20px 20px 20px 20px' }}>
				
				<div style={{display: 'flex', marginBottom: '15px'}}>
					<FieldList_MultilangString
						instance={instance} path={'name'} parentField={parentField} plain={plain}
						labelEmptyToHeader={true}
						readOnly={readOnly}
						styles={{divMain: {flexGrow: '1'}}}
					/>
				</div>
				<div style={{display: 'flex', marginBottom: '15px'}}>
					
					<div style={{minWidth: '500px', flexGrow: '1', padding: '10px', border: '1px solid  blue', marginRight: '15px'}}>
						<FieldList_MultilangString
							instance={instance} path={'editionStatement'} parentField={parentField} plain={plain}
							labelEmptyToHeader={true}
							readOnly={readOnly}
							styles={{divMain: {flexGrow: '1', marginBottom: '15px'}}}
						/>
						
						<FieldList_Enum
							instance={instance} path={'editionType'} parentField={parentField} plain={plain}
							labelEmptyToHeader={true}
							readOnly={readOnly}
							styles={{divMain: {flexGrow: '1', marginBottom: '15px'}}}
						/>

						<FieldList_MultilangString
							instance={instance} path={'material'} parentField={parentField} plain={plain}
							labelEmptyToHeader={true}
							readOnly={readOnly}
							styles={{divMain: {flexGrow: '1', marginBottom: '15px'}}}
						/>

					</div>
					
					<div style={{minWidth: '400px', flexGrow: '1', padding: '10px', border: '1px solid  blue'}}>

						<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
							<FieldEnum instance={instance} path={'country'} parentField={parentField} plain={plain} 
								readOnly={readOnly}
								styles={{ select: {flexGrow: '1'}}} 
							/>
						</div>

						<FieldList_MultilangString
							instance={instance} path={'place'} parentField={parentField} plain={plain}
							labelEmptyToHeader={true}
							readOnly={readOnly}
							styles={{divMain: {flexGrow: '1', marginBottom: '15px'}}}
						/>
						
						
						<div style={{display: 'flex', marginBottom: '15px', alignItems: 'center'}}>
							<FieldEnum instance={instance} path={'year'} parentField={parentField} plain={plain} 
								readOnly={readOnly}
								styles={{ select: {flexGrow: '1', marginRight: '20px'}}} 
							/>
							<FieldEnum instance={instance} path={'quarter'} parentField={parentField} plain={plain} 
								readOnly={readOnly}
								styles={{ select: {flexGrow: '1', marginRight: '20px'}}} 
							/>
							<FieldEnum instance={instance} path={'month'} parentField={parentField} plain={plain} 
								readOnly={readOnly}
								styles={{ select: {flexGrow: '1'}}} 
							/>
						</div>

						<div style={{display: 'flex', marginBottom: '15px', alignItems: 'center'}}>
							<FieldInteger instance={instance} path={'circulation'} parentField={parentField} plain={plain}
								readOnly={readOnly}
								styles={{ input: {flexGrow: '1', marginRight: '20px'} }}
							/>
							<FieldString instance={instance} path={'price'} parentField={parentField} plain={plain}
								readOnly={readOnly}
								styleInput={{flexGrow: '1'}}
							/>
						</div>
					</div>
				</div>
				
				<div style={{display: 'flex', marginBottom: '15px'}}>
					<div style={{flexGrow: '1'}}>
						<FieldList_TableGroup instance={instance} path={'editionSpecial'} parentField={parentField}
							plain={plain} plainDirtyCounter={plain.state.plainDirtyCounter} 
							readOnly={readOnly}
							table={{
								columns: [
									{ columnId: 'language', styles: {tdHeader: {width: '200px'}} },
									{ columnId: 'type', styles: {tdHeader: {width: '200px'}} },
									{ columnId: 'value' },
								],
							}}
							styles={{
								table: {width: '100%'},
								trHeader: {height: '30px'}
							}}
						/>
					</div>
				</div>

				<FieldList_MultilangString
					instance={instance} path={'comment'} parentField={parentField} plain={plain}
					labelEmptyToHeader={true}
					table={{width: '100%', styles: {}}}
					readOnly={readOnly}
				/>

				<FieldList_Reference path={'publisherAuthority'} instance={instance} parentField={parentField} plain={plain} 
					styles={{divMain: {marginBottom: '10px'}}}
					labelEmptyToHeader={true}
					refNodes={refEditionAuthorityNodes}
					readOnly={readOnly}
				/>
			</div>
		)
	}
}

const refEditionAuthorityNodes = [
	{
		classId: 'AuthorityPublisher', plainFormPath: AUTHORITY_PUBLISHER_PATH, 
		selectInstanceFormId: FORM_AUTHORITY_PUBLISHER_TABLE,
		selectInstanceFormTitle: 'Авторитетні записи'
	}
];

export default ProductPlainPage;
